import React from "react";
import { theme } from 'antd';
import { PlusOutlined,} from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_TRUCK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import { PATH } from "../../routes/CustomRoutes";
import DispenseChemicalModal from "./DispenseChemicalModal";
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";
import { DELETE } from "../../frameworks/HttpClient";
import { toHumanDate } from "../../frameworks/Util";

export default function DispenseChemicalAllList() { 
  const tableRef = React.useRef(null);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [dispenseTarget, setDispenseTarget] = React.useState();
  const {
    token: { colorSuccess },
  } = theme.useToken();

  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      width : 100,
      key: 'action',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <CustomDeleteConfirmButton
              title={`ลบรายการจ่ายสารเคมี`}
              content={"คุณต้องการลบรายการจ่ายสารเคมีใช่หรือไม่"}
              onOk={ async() => {
                await handleDelete(original.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
          </div>
      )}
    },
    {
      title: 'วันที่จ่าย',
      dataIndex: 'date',
      key: 'date',
      dateSearcher: true,  // Search by date selection
      render: (value) => toHumanDate(value)
    },
    {
      title: 'ผู้ขายน้ำยางสด',
      dataIndex: 'supplier_name',
      key: 'supplier_name',
      searcher: true,
      render : (value, original) => <a onClick={() => window.open(`${window.origin}${PATH.DISPENSE_CHEMICAL}/seller/${original.supplier}/`)}>{value}</a>
    },
    {
      title: 'ทะเบียนรถ',
      dataIndex: 'license_plate',
      key: 'license_plate',
      searcher: true,
    },
    {
      title: 'NH4OH',
      children: [
        {
          title: 'Lot No.',
          dataIndex: '',
          key: 'lot_no',
          render: (value, original) => value.transfer_details.find((e) => e.chemical === 'NH4OH') ? value.transfer_details.find((e) => e.chemical === 'NH4OH').stock_lot_no : '-'
        },
        {
          title: 'ปริมาณ (Kg)',
          dataIndex: '',
          key: 'hn30h_weight',
          render: (value, original) => { return value.transfer_details.find((e) => e.chemical === 'NH4OH') ? value.transfer_details.find((e) => e.chemical === 'NH4OH').amount : '-' }
        },
      ],
    },
    {
      title: 'TZ',
      children: [
        {
          title: 'Lot No.',
          dataIndex: '',
          key: 'lot_no',
          render: (value, original) => value.transfer_details.find((e) => e.chemical === 'TZ') ? value.transfer_details.find((e) => e.chemical === 'TZ').stock_lot_no : '-'
        },
        {
          title: 'ปริมาณ (Kg)',
          dataIndex: '',
          key: 'tz_weight',
          render: (value, original) => value.transfer_details.find((e) => e.chemical === 'TZ') ? value.transfer_details.find((e) => e.chemical === 'TZ').amount : '-'
        },
      ],
    },
    {
      title: 'ผู้จ่าย',
      dataIndex: 'created_by_name',
      key: 'created_by_name',
      searcher: true,
    },
  ]

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const handleDelete = async(id) => {
    setErrorMessages(null)
    try {
      await DELETE(`${URL_TRUCK.CHEMICAL_TRANSFER}${id}/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  return(
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
        type='primary'
        override={colorSuccess}
        icon={<PlusOutlined style={{ fontSize : 14 }}/>}
        onClick={() => setDispenseTarget('add')}
        style={{ float : 'right', marginBottom : 10 }}
      >
        จ่ายสารเคมี
      </ColorButton>

      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_TRUCK.CHEMICAL_TRANSFER}
      />

      <DispenseChemicalModal
        open={dispenseTarget ? true : false}
        onClose={() => {
          setDispenseTarget(null);
        }}
        onUpdate={() => {
          setDispenseTarget(null);
          refreshData();
        }}
        target={dispenseTarget}
      />
    </div>
  )
}